import { combineReducers } from "redux";
import { reducer as form } from "redux-form";
import reduxWindow from "redux-window";
import { reducer as auth } from "modules/auth";
import { reducer as articles } from "modules/articles";
import { reducer as namedLocations } from "modules/named-locations";
import { reducer as analytics } from "modules/analytics";
import {
  agency,
  agencyBookingDesks,
  agencyFinancials,
  agencyList,
  agencyUser,
  bookedEvent,
  bookedEvents,
  businessUnits,
  company,
  companyBranches,
  companyList,
  companyUsers,
  corporateAccount,
  corporateAccountDocument,
  corporateAccountDocumentsCategoryList,
  corporateAccountDocumentsList,
  corporateAccountList,
  corporateAccountLocation,
  corporateAccountLocationsList,
  corporateAccountPermissions,
  corporateAccountUsers,
  corporateBookingDesks,
  corporateDepartment,
  corporateDepartments,
  countries,
  draftEnquiry,
  enquiryLogReport,
  eventStatus,
  hotelGroup,
  hotelGroups,
  hotelGroupTypes,
  hotelGroupVenues,
  industryEvents,
  monthlyEventValuesReport,
  nominalCodes,
  notes,
  proposal,
  publicEvents,
  reportingFigures,
  roles,
  search,
  selectedAgencies,
  shortlist,
  singleUser,
  siteVisits,
  snapshotReport,
  spendReport,
  cashFlowReport,
  userInvite,
  userInvites,
  vatRate,
  venues,
  annualReport,
  globalEvents,
  agencyFeatures,
  snapshotReportForHotelGroups,
  hotelGroupsSnapshotReport,
  venue,
  venueFinancials,
  snapshotAnnualReport,
  companyLifetimeStatsTargets,
  companyLifetimeStats,
  companyFiles,
  companyFile,
  companyUser,
  myPreferredProgrammes,
  preferredProgrammeSpendReport,
  hotelGroupUsers,
} from "redux/reducers/reducer";
import { reducer as brand } from "modules/brand";
import { reducer as industries } from "modules/industries";
import { invoicePdfs } from "./redux/reducers/invoicePdfs";
import { preferredProgrammes } from "./redux/reducers/preferred-programs";
import {
  commercialDeal,
  commercialDeals,
} from "./redux/reducers/commercial-deals";

export default combineReducers({
  form,
  auth,
  brand,
  reduxWindow,
  articles,
  namedLocations,
  analytics,
  companyList,
  company,
  countries,
  agencyList,
  agency,
  agencyFinancials,
  agencyUser,
  roles,
  vatRate,
  singleUser,
  notes,
  industries,
  corporateAccountList,
  corporateAccount,
  corporateAccountDocument,
  corporateAccountDocumentsList,
  corporateAccountDocumentsCategoryList,
  publicEvents,
  industryEvents,
  bookedEvents,
  bookedEvent,
  nominalCodes,
  reportingFigures,
  corporateBookingDesks,
  corporateAccountUsers,
  corporateDepartments,
  corporateDepartment,
  userInvite,
  userInvites,
  corporateAccountLocationsList,
  corporateAccountLocation,
  eventStatus,
  draftEnquiry,
  venues,
  proposal,
  shortlist,
  enquiryLogReport,
  snapshotReport,
  snapshotReportForHotelGroups,
  spendReport,
  companyUsers,
  companyUser,
  monthlyEventValuesReport,
  siteVisits,
  agencyBookingDesks,
  businessUnits,
  companyBranches,
  selectedAgencies,
  corporateAccountPermissions,
  hotelGroups,
  hotelGroup,
  hotelGroupUsers,
  hotelGroupVenues,
  hotelGroupTypes,
  search,
  cashFlowReport,
  invoicePdfs,
  annualReport,
  globalEvents,
  agencyFeatures,
  venue,
  hotelGroupsSnapshotReport,
  commercialDeals,
  commercialDeal,
  venueFinancials,
  snapshotAnnualReport,
  companyLifetimeStatsTargets,
  companyLifetimeStats,
  companyFiles,
  companyFile,
  preferredProgrammes,
  myPreferredProgrammes,
  preferredProgrammeSpendReport
});
